import { ContactList } from 'common/contact/components/List/ContactList';
import { createRoute } from 'common/helper/createRoute';
import { Navigate } from 'react-router-dom';
import { CommonRouteNames } from '../model/CommonRouteNames';
import { SurveyPage } from 'application/components/Survey/Survey';

export const commonRoutes = createRoute([
  {
    path: `/${CommonRouteNames.CONTACT}`,
    element: <ContactList />,
  },
  {
    path: `/${CommonRouteNames.SURVEY}`,
    element: <SurveyPage />,
  },
  {
    path: '*',
    element: <Navigate to={`${CommonRouteNames.CONTACT}`} replace={true} />,
  },
]);
